export function getBookingPaymentGateway(booking: any): "Stripe" | "HyperPay" | "Payfort" | null {
  if (!booking) return null;

  const mode = (booking.payment_mode || "").trim();
  if (mode === "Stripe" || mode === "Payfort" || mode === "HyperPay") {
    return mode;
  }

  if (booking.isStripePayment === true) return "Stripe";
  if (mode === "Hyper") return "HyperPay";

  return "Payfort";
}

export function isStripeBooking(booking: any): boolean {
  return getBookingPaymentGateway(booking) === "Stripe";
}

export function isHyperPayBooking(booking: any): boolean {
  return getBookingPaymentGateway(booking) === "HyperPay";
}

export function getBookingPaymentReferencePrefix(booking: any): string {
  const gateway = getBookingPaymentGateway(booking);
  if (gateway === "Stripe") return "Stripe#";
  if (gateway === "HyperPay") return "HyperPay#";
  return "Pay-fort#";
}
